import {useEffect} from "react";
import {useMap} from "react-leaflet";
import {LatLngBounds} from "leaflet";

export default function FitTourneeToLaveuse({points, trigger}) {
    const map = useMap();

    useEffect(() => {
        if (!trigger || !points || points.length === 0) return;
        const bounds = new LatLngBounds(points);
        map.fitBounds(bounds, {padding: [50, 50]});
    }, [trigger]); // eslint-disable-line react-hooks/exhaustive-deps

    return null;
}
